// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type SystemInformation } from "../../api";
import { useGetSystemInformation as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useSystemInformationQueryKey(): QueryKey {
  return ["api", "v1", "system"];
}

export function useSystemInformation(
  options: Omit<
    UseQueryOptions<SystemInformation, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): SystemInformation {
  const getter = useGetter();
  return useQuery(useSystemInformationQueryKey(), () => getter(), options)
    .data!;
}
